import type {CpcCampaignModalState} from 'modules/Cpc/Details/types';

import {Button, Modal} from '@ds/components';

type CampaignActionModalProps = {
  action?: CpcCampaignModalState;
  isPaused: boolean;
  onClose: () => void;
  onConfirm: (action: CpcCampaignModalState) => void;
};

const CampaignActionModal: React.FC<CampaignActionModalProps> = ({
  action,
  isPaused,
  onClose,
  onConfirm
}) => {
  const title =
    action === 'renewal'
      ? 'آیا از توقف کامل کمپین مطمئن هستید؟'
      : action === 'remove'
        ? 'آیا از حذف این کمپین مطمئن هستید؟'
        : isPaused
          ? 'آیا از شروع دوباره این کمپین مطمئن هستید؟'
          : 'آیا از توقف این کمپین مطمئن هستید؟';

  const description =
    action === 'remove'
      ? 'با حذف کمپین تمامی اطلاعاتی که وارد کردید حذف می‌شود.'
      : action === 'renewal'
        ? 'آیا به توقف کامل کمپین موافق هستید؟'
        : isPaused
          ? 'آیا به شروع دوباره کمپین موافق هستید؟'
          : 'با توقف کمپین، کلیک‌های شما متوقف می‌شود.';

  return (
    <Modal
      show={Boolean(action)}
      onClose={onClose}
      defaultHeader
      title={title}
      footer={
        <div className="flex justify-between gap-3 border-t border-gray-03 px-4 py-3">
          <Button variant="link" color="secondary" onClick={onClose}>
            انصراف
          </Button>
          <Button
            color="destructive"
            onClick={() => {
              if (action) {
                onConfirm(action);
              }
            }}
          >
            بله
          </Button>
        </div>
      }
    >
      <p className="px-4 py-3 text-body-sm text-neutral-fg">{description}</p>
    </Modal>
  );
};

export default CampaignActionModal;
